import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { grey, blue } from '@mui/material/colors';

export const ActionButton = styled(Button)(({ theme }) => ({
  fontSize: 13,
  textTransform: 'uppercase',
  marginRight: theme.spacing(1),
  color: grey[700],
  '&:hover': {
    backgroundColor: 'transparent',
    color: grey[900],
  },
}));

export const PrimaryButton = styled(Button)(() => ({
  fontSize: 13,
  borderRadius: 0,
  textTransform: 'capitalize',
  padding: '6px 12px',
  backgroundColor: blue[900],
  color: 'white',
  '&:hover': {
    backgroundColor: blue[800],
  },
  '&:disabled': {
    backgroundColor: grey[200],
    color: grey[600],
    opacity: 0.5,
  },
}));

export const OutlinedButton = styled(Button)(() => ({
  fontSize: 13,
  padding: '6px 12px',
  borderRadius: 0,
  textTransform: 'capitalize',
  border: `1px solid ${grey[200]}`,
  '&:hover': {
    backgroundColor: 'transparent',
    color: grey[900],
  },
  '&:disabled': {
    backgroundColor: grey[200],
    color: grey[600],
    opacity: 0.5,
  },
})); 